import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { AbstractDynamicComponent } from '@components/abstracts';
import { FilterToggleGroupComponent } from '@shared/components/filter-toggle-group';
import { GridSkeletonComponent } from '@shared/components/grid-skeleton';
import { Image } from '@shared/components/image/models';
import { OptionCardComponent } from '@shared/components/option-card';
import { PopinImageComponent } from '@shared/components/popin-image';
import { EmptyData } from '@shared/models';
import { GenerateRangePipe } from '@shared/pipe';
import { DialogService } from '@shared/services/dialog';
import { ElasticSearchService } from '@shared/services/elastic-search';
import { Handle } from '@shared/services/elastic-search/models';
import { UrlParamsService } from '@shared/services/url-params';
import { filter, switchMap } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-listing-poignees',
  templateUrl: './listing-poignees.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FilterToggleGroupComponent, GridSkeletonComponent, OptionCardComponent, GenerateRangePipe, NgStyle],
})
export class ListingPoigneesComponent extends AbstractDynamicComponent<EmptyData> {
  protected readonly filterName = 'filter_handle_style';
  protected readonly currentIndices = signal<number[]>([]);
  private readonly filtersUrlParam = inject(UrlParamsService).param(this.filterName);
  private readonly elasticSearchService = inject(ElasticSearchService);
  protected readonly handles = toSignal(
    toObservable(this.filtersUrlParam).pipe(
      filter((param): param is string => !!param),
      switchMap((param) => this.elasticSearchService.getHandles(param.split('__'))),
      tap((handles) => this.buildImageIndices(handles))
    )
  );
  protected readonly filters = toSignal(this.elasticSearchService.getHandlesFilter());
  private readonly dialogService = inject(DialogService);

  updateIndex(index: number, value: number) {
    this.currentIndices.update((currentIndices) => {
      currentIndices[index] = value;
      return currentIndices;
    });
  }

  openVisualFullScreenModal(image: Image): void {
    this.dialogService.openDialog(PopinImageComponent, 'FULL_SCREEN', {
      data: {
        image,
      },
    });
  }

  private buildImageIndices(handles: Handle[]) {
    this.currentIndices.set(handles.map((_) => 0));
  }
}
